export function sortByClosestDate<T>(items: readonly T[], getDate: (item: T) => string | null | undefined, now = Date.now()) {
  return [...items].sort((left, right) => {
    const leftTime = dateValue(getDate(left))
    const rightTime = dateValue(getDate(right))
    const distance = Math.abs(leftTime - now) - Math.abs(rightTime - now)
    return distance || leftTime - rightTime
  })
}

function dateValue(value: string | null | undefined) {
  if (!value) return Number.MAX_SAFE_INTEGER
  const parsed = new Date(value).valueOf()
  return Number.isFinite(parsed) ? parsed : Number.MAX_SAFE_INTEGER
}
